import React, { FC, useEffect, useState } from 'react';
import { Checkbox, Col, Form, Grid, Input, Modal, notification, Radio, Row, Space } from 'antd';
import Bucket from '/icons/bucket.svg';
import Button from 'mixins/ui/button/button';
import { addGovService, updateGovService } from '../actions';
import * as dayjs from 'dayjs';
import { convertToArray, guidGenerator } from 'mixins/helpers';

const GovServicesAdminAddModal: FC<any> = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [lang, setLang] = useState('kk');
    const [kk, setKk] = useState<any>();
    const [ru, setRu] = useState<any>();
    const [en, setEn] = useState<any>();
    const [qq, setQq] = useState<any>();
    const [isSave, setIsSave] = useState<object>();
    const brakpoints = Grid.useBreakpoint();

    const [form] = Form.useForm();

    const getLangData = (l: string) => {
        switch (l) {
            case 'kk':
                return kk;
            case 'ru':
                return ru;
            case 'en':
                return en;
            case 'qq':
                return qq;
        }
    };

    const updateData = (langValue: string, isSave = false): void => {
        const formValues = form.getFieldsValue();

        form.validateFields().then(() => {
            setLang(langValue);

            const data: any = {};
            data.name = formValues[`name`];

            if (formValues.links) {
                data.links = formValues.links.map((x) => ({
                    title: x.title,
                    link: x.link,
                }));
            }

            switch (lang) {
                case 'kk':
                    setKk(data);
                    break;
                case 'ru':
                    setRu(data);
                    break;
                case 'en':
                    setEn(data);
                    break;
                case 'qq':
                    setQq(data);
                    break;
            }

            const langData = getLangData(langValue);

            if (!langData || !langData.name) {
                form.resetFields(['name']);
            }

            form.setFieldsValue(langData);

            if (isSave) {
                setIsSave({});
            }
        });
    };

    const processData = (data: any) => {
        data.links = convertToArray(data.links);
        return data;
    };

    const handleRadioChange = (e) => {
        updateData(e.target.value);
    };

    useEffect(() => {
        if (props.item) {
            setKk(processData(props.item.kk));
            setRu(processData(props.item.ru));
            setEn(processData(props.item.en));
            setQq(processData(props.item.qq));

            form.setFieldsValue({
                ...processData(props.item[lang]),
                status: props.item.status,
            });
        }
    }, [props.item]);

    useEffect(() => {
        if (props.tab) {
            form.setFieldValue('type', props.tab);
            setLang('kk');
        }
    }, [props.tab]);

    const resetFields = () => {
        form.resetFields();
        form.setFieldValue('type', props.tab);
        setLang('kk');
        setRu(undefined);
        setKk(undefined);
        setEn(undefined);
        setQq(undefined);
    };

    const handleCancel = () => {
        props.handleCancel();
        resetFields();
    };

    const getData = (): any => {
        const formValues = form.getFieldsValue();

        const data: any = {};
        data.id = props.item ? props.item.id : guidGenerator();
        data.type = formValues.type;
        data.ru = ru;
        data.kk = kk;
        data.en = en;
        data.qq = qq;
        data.createdAt = props.item ? props.item.createdAt : dayjs().toISOString();
        data.updatedAt = dayjs().toISOString();
        data.status = formValues.status;

        return data;
    };

    const validateData = (): boolean => {
        const lvArr = [ru, kk, en, qq];

        let counter = 0;

        lvArr.forEach((x) => {
            if (x && x.name) {
                counter++;
            }
        });

        return counter === lvArr.length;
    };

    const handleSave = (data: any) => {
        setIsLoading(true);

        addGovService(data)
            .then(() => {
                notification['success']({
                    message: 'Данные успешно сохранены и опубликованы!',
                });
                props.handleOk();
                resetFields();
            })
            .finally(() => setIsLoading(false));
    };

    const handleUpdate = (data: any) => {
        setIsLoading(true);

        updateGovService(data)
            .then(() => {
                notification['success']({
                    message: 'Данные успешно обновлены и опубликованы!',
                });
                props.handleOk();
                resetFields();
            })
            .finally(() => setIsLoading(false));
    };

    const handleSubmit = () => {
        updateData(lang, true);
    };

    useEffect(() => {
        if (isSave) {
            if (validateData()) {
                const data = getData();

                if (props.item) {
                    handleUpdate(data);
                } else {
                    handleSave(data);
                }
            } else {
                notification['warning']({
                    message: 'Предупреждение',
                    description: 'Не все обязательные поля заполнены!',
                });
            }
        }
    }, [isSave]);

    return (
        <Modal
            title="Добавить государственную услугу"
            visible={props.isModalOpen}
            onCancel={handleCancel}
            okText="Опубликовать"
            footer={[
                <Button
                    key="back"
                    onClick={handleCancel}
                >
                    Отмена
                </Button>,
                <Button
                    key="submit"
                    color="gold"
                    onClick={handleSubmit}
                    loading={isLoading}
                >
                    Добавить
                </Button>,
            ]}
        >
            <Form
                form={form}
                layout="vertical"
            >
                <Row
                    gutter={16}
                    className="Row"
                >
                    <Col span={24}>
                        <Form.Item
                            className="mt-4"
                            label="Тип услуги"
                            name="type"
                            rules={[
                                {
                                    required: true,
                                    message: 'Пожалуйста, выберите тип услуги',
                                },
                            ]}
                        >
                            <Radio.Group required>
                                <Radio value="tax">Налоговая</Radio>
                                <Radio value="custom">Таможенная</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item>
                            <Radio.Group
                                buttonStyle="solid"
                                value={lang}
                                onChange={handleRadioChange}
                            >
                                <Radio.Button
                                    value="kk"
                                    style={{
                                        width: brakpoints.xs ? 122 : undefined,
                                    }}
                                >
                                    Қазақша
                                </Radio.Button>
                                <Radio.Button
                                    value="ru"
                                    style={{
                                        width: brakpoints.xs ? 122 : undefined,
                                    }}
                                >
                                    Русский
                                </Radio.Button>
                                <Radio.Button
                                    value="en"
                                    style={{
                                        width: brakpoints.xs ? 122 : undefined,
                                    }}
                                >
                                    English
                                </Radio.Button>
                                <Radio.Button
                                    value="qq"
                                    style={{
                                        width: brakpoints.xs ? 122 : undefined,
                                    }}
                                >
                                    Qazaqsha
                                </Radio.Button>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="Введите название услуги"
                            name="name"
                            rules={[
                                {
                                    required: true,
                                    message: 'Это поле обязательно для заполнения!',
                                },
                                {
                                    max: 255,
                                    message: 'Допустимое колличество символов 255',
                                },
                            ]}
                        >
                            <Input type="text" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Row>
                            <Form.List name="links">
                                {(fields, { remove, add }) => {
                                    return (
                                        <Col span={24}>
                                            <Row gutter={24}>
                                                {fields.map(({ key, name }, index) => {
                                                    return (
                                                        <Col
                                                            key={key}
                                                            xs={24}
                                                            md={12}
                                                            xl={8}
                                                        >
                                                            <Space direction="vertical">
                                                                <Form.Item
                                                                    name={[name, `title`]}
                                                                    className="wrapper"
                                                                    label={
                                                                        <div
                                                                            style={{
                                                                                width: '100%',
                                                                                display: 'flex',
                                                                                alignItems:
                                                                                    'center',
                                                                                justifyContent:
                                                                                    'space-between',
                                                                            }}
                                                                        >
                                                                            <div>
                                                                                Ссылка {index + 1}
                                                                            </div>
                                                                            {fields.length > 1 && (
                                                                                <Bucket
                                                                                    className="bucket"
                                                                                    onClick={() =>
                                                                                        remove(name)
                                                                                    }
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    }
                                                                >
                                                                    <Input placeholder="введите название" />
                                                                </Form.Item>

                                                                <Form.Item name={[name, `link`]}>
                                                                    <Input placeholder="введите ссылку" />
                                                                </Form.Item>
                                                            </Space>
                                                        </Col>
                                                    );
                                                })}
                                            </Row>
                                            <Button
                                                type="link"
                                                className="link__add"
                                                uppercase={false}
                                                onClick={add}
                                            >
                                                Добавить еще ссылку
                                            </Button>
                                        </Col>
                                    );
                                }}
                            </Form.List>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="status"
                            className="mt-4"
                            valuePropName="checked"
                        >
                            <Checkbox>Опубликовать</Checkbox>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default GovServicesAdminAddModal;
